module.exports = __webpack_public_path__ + "img/l7.6add927d.png";